import { render, staticRenderFns } from "./ImageBox.vue?vue&type=template&id=97159ed2&scoped=true"
import script from "./ImageBox.vue?vue&type=script&lang=js"
export * from "./ImageBox.vue?vue&type=script&lang=js"
import style0 from "./ImageBox.vue?vue&type=style&index=0&id=97159ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97159ed2",
  null
  
)

export default component.exports